export class OperacionCambioMatriculaDto {
  matricula: string;
  marca: string;
  modelo: String;
  color: string;
}
